import React, { useState } from 'react';
import connect from "react-redux/lib/connect/connect";
import { ClearSportsList, SetClicked, SetLeague, SetLocation, SetSearchType, SetSearchValue, SetSportId } from '../../../common/actions/sportsAction';

const searchData = [
    {
        name: "팀",
        value: "team"
    },
    {
        name: "리그",
        value: "league"
    },
    {
        name: "지역",
        value: "location"
    }
]

const SportsSearch = (props) => {

    const [flag, setFlag] = useState("");
    const [flagType, setFlagType] = useState("");
    const {mainsportsclicked} = props.sports

    const [inputs, setInputs] = useState({
        searchType: 'team',
        searchValue: ''
    });
    const { searchType, searchValue } = inputs;


    const onChange = (e) => {
        const { value, name } = e.target;
        setInputs({
            ...inputs,
            [name]: value
        });
    };

    const onReset = () => {
        setInputs({
            searchType:"team",
            searchValue:""
        })
    }

    const onSearch = () => {
        if((flag != searchValue) || (flagType != searchType) || mainsportsclicked) {
            props.ClearSportsList();
            setFlag(searchValue);
            setFlagType(searchType);
            props.SetClicked(false)
        }
        props.SetSportId("");
        props.SetLeague("");
        props.SetLocation("");
        props.SetSearchType(searchType);
        props.SetSearchValue(searchValue);
        // onReset();
    }

    const onEnter = (e) => {
        // e.preventDefault();

        if (e.key === 'Enter') {
            // e.preventDefault();
            onSearch();
        }
    }

    return (
        <div className="left_serch_box">
            <div className="left_serch">
                <select
                    name="searchType"
                    value={searchType}
                    onChange={onChange}
                    className="sports-search-input " >
                    {
                        searchData.map((data, index) => {
                            return (<option value={data.value} key={index}>{data.name}</option>)
                        })
                    }
                </select>
            </div>
            <div className="left_serch" onKeyDown={onEnter}>
                <input type="text" name="searchValue" value={searchValue} onChange={onChange} className="left_serch_input" />
                <button className="left_serch_btn" onClick={onSearch}><img style={{ filter: "grayscale(1)" }} src="../images/icon_serch.png" /></button>
            </div>
        </div>
    );
}

const mapStateToProps = state => ({
    sports: state.sports,
});

export default connect(
    mapStateToProps,
    {
        ClearSportsList,
        SetSearchValue,
        SetSearchType,
        SetSportId,
        SetLeague,
        SetLocation,
        SetClicked
    }
)(SportsSearch);


// WEBPACK FOOTER //
// ./src/components/sports/sportscomponent/SportsSearch.js